import React from 'react';
import PropTypes from 'prop-types';
import { formatValue, NumeralTypes } from '@common/utils/formatNumberValue';

export { NumeralTypes, formatValue };

const Numeral = ({
  additionalClassNames,
  children,
  type,
  customFormat,
  fixedPrecision,
  acceptRaw = false,
}) => {
  const value = formatValue({ value: children, type, customFormat, fixedPrecision, acceptRaw });

  return <span className={additionalClassNames(value)}>{value}</span>;
};

Numeral.propTypes = {
  type: PropTypes.oneOf(Object.values(NumeralTypes)),
  additionalClassNames: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customFormat: PropTypes.string,
  fixedPrecision: PropTypes.string,
  acceptRaw: PropTypes.bool,
};

Numeral.defaultProps = {
  additionalClassNames: () => '',
  customFormat: '',
  fixedPrecision: '',
};

export default Numeral;
